import get from 'lodash/get';

import { approvalStatuses, inActiveStatuses } from './constants';

export function isApprovalReviewed(approval) {
  return [approvalStatuses.granted, approvalStatuses.denied].includes(
    approval.status,
  );
}

export function getDiffKey(changeRequest) {
  return inActiveStatuses.includes(changeRequest.status)
    ? 'archivedDraftDiff'
    : 'draftDiff';
}

export function getCampaignDiff(changeRequest) {
  const diffKey = getDiffKey(changeRequest);
  return get(changeRequest, `draftCampaigns[0].${diffKey}`, null);
}

export function getCampaignLineDiff(changeRequest, line) {
  const diffKey = getDiffKey(changeRequest);
  return get(line, diffKey, null);
}
